import { createSelector } from '@ngrx/store';

import { bookingRootSelector } from './booking-root.selector';
import { BookingState } from '../state/booking.state';

export const getUiBookingState = createSelector(
  bookingRootSelector,
  (state: BookingState) => state.ui
);

